/**
 * theme store - brand 테마 상태. 'white'(기본 light, blue brand)/'green'(green brand) 토글.
 * [data-theme='green'] 셀렉터가 brand color ramp 를 재바인딩. localStorage 자동 persist.
 */
import { defineStore } from 'pinia';

const THEMES = ['white', 'green'];

/** 개인 설정이 없을 때의 시스템 기본. 회사 단위 기본값은 두지 않는다. */
export const DEFAULT_THEME = 'white';

function applyTheme(name) {
  const html = document.documentElement;
  if (name === 'green') {
    html.dataset.theme = 'green';
  } else {
    delete html.dataset.theme;        // white = default :root (blue brand)
  }
}

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: 'white',                   // 'white' | 'green'
  }),
  getters: {
    isGreen: (s) => s.theme === 'green',
    options: () => THEMES,
  },
  actions: {
    /** 확정 - 상태 + 기기 캐시(persist) + DOM. */
    setTheme(name) {
      const next = THEMES.includes(name) ? name : DEFAULT_THEME;
      this.theme = next;
      applyTheme(next);
    },
    /** 미리보기 - DOM 만 바꾼다. 저장하지 않은 선택이 기기에 남지 않게. */
    previewTheme(name) {
      applyTheme(THEMES.includes(name) ? name : DEFAULT_THEME);
    },
    /** 로그아웃 - 다음 사용자에게 이전 사용자의 테마가 비치지 않게 기본으로 되돌린다. */
    resetTheme() {
      this.theme = DEFAULT_THEME;
      applyTheme(DEFAULT_THEME);
    },
    /** 앱 mount 직후 1회 호출 - persist 로 복원된 state 를 DOM 에 반영. */
    applyCurrent() {
      applyTheme(this.theme);
    },
  },
  persist: {
    storage: localStorage,
    key: 'insait.theme',
  },
});
